import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  List,
  ListItem,
} from "@mui/material";
import { useState, useEffect } from "react";

const regex =
  /Ada field (\S+) has (\S+) conversion issues and (\S+) missing values/;

function ConversionErrorTable({ errors }) {
  const [tableRows, setTableRows] = useState([]);
  const [listItems, setListItems] = useState([]);

  useEffect(() => {
    const conversionErrors = [];
    const otherErrors = [];

    if (errors) {
      errors.forEach((error) => {
        if (error.match(regex)) {
          const matches = error.match(regex);
          conversionErrors.push({
            fieldName: matches[1],
            invalid: matches[2],
            missing: matches[3],
          });
        } else {
          otherErrors.push(error);
        }
      });

      setTableRows(conversionErrors);
      setListItems(otherErrors);
    }
  }, [errors]);

  return (
    <>
      {listItems && (
        <List>
          {listItems.map((row, index) => (
            <ListItem key={index}>{row}</ListItem>
          ))}
        </List>
      )}
      {tableRows.length > 0 && (
        <TableContainer>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Field Name</TableCell>
                <TableCell align="right">Invalid Format</TableCell>
                <TableCell align="right">Missing</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tableRows.map((row) => (
                <TableRow
                  key={row.fieldName}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    {row.fieldName}
                  </TableCell>
                  <TableCell align="right">{row.invalid}</TableCell>
                  <TableCell align="right">{row.missing}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </>
  );
}

export default ConversionErrorTable;
